import { createContext, useContext } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";

export const HubContext = createContext(null);
export const useHub = () => useContext(HubContext);

// Page « hub » : bandeau compact (fil d'Ariane + onglets ?tab=) puis le module existant, inchangé.
export function HubPage({ path, title, desc, flow, icon: Icon, tabs }) {
  const [params, setParams] = useSearchParams();
  const active = tabs.find((t) => t.key === params.get("tab")) || tabs[0];
  const Active = active.component;
  const select = (key) => setParams({ tab: key }, { replace: false });
  return (
    <div data-testid={`hub-${path.replace("/app/", "")}`} className="min-h-screen">
      <div className="sticky top-0 z-30 bg-zinc-950/95 backdrop-blur border-b border-zinc-800 px-6 pt-4 pb-0" data-testid="hub-bar">
        <nav className="flex items-center gap-1.5 text-xs text-zinc-500 mb-2" data-testid="hub-breadcrumb">
          <Link to="/app" className="hover:text-amber-400 transition-colors">Accueil</Link>
          {flow && <><CaretRight size={11} weight="bold" className="text-zinc-700" /><span>{flow}</span></>}
          <CaretRight size={11} weight="bold" className="text-zinc-700" />
          <span className="text-zinc-300 font-semibold">{title}</span>
          <CaretRight size={11} weight="bold" className="text-zinc-700" />
          <span className="text-amber-400">{active.label}</span>
        </nav>
        <div className="flex items-end justify-between gap-6 flex-wrap">
          <div className="flex items-center gap-3 pb-3 min-w-0">
            {Icon && <Icon size={26} weight="duotone" className="text-amber-500 shrink-0" />}
            <div className="min-w-0">
              <h1 className="text-xl font-bold text-zinc-50 leading-tight truncate" data-testid="hub-title">{title}</h1>
              {desc && <p className="text-xs text-zinc-500 truncate">{desc}</p>}
            </div>
          </div>
          <div className="flex gap-1 overflow-x-auto custom-scrollbar" role="tablist" data-testid="hub-tabs">
            {tabs.map((t) => (
              <button key={t.key} type="button" role="tab" aria-selected={t.key === active.key} onClick={() => select(t.key)}
                data-testid={`hub-tab-${t.key}`}
                className={`whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
                  t.key === active.key ? "border-amber-500 text-amber-400" : "border-transparent text-zinc-400 hover:text-zinc-100 hover:border-zinc-700"}`}>
                {t.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <HubContext.Provider value={{ path, title, tab: active.key }}>
        <div key={active.key} className="animate-in fade-in duration-300"><Active /></div>
      </HubContext.Provider>
    </div>
  );
}

export default HubPage;
